// extracted by mini-css-extract-plugin
export var typingIndicator = "_o8-0";